import React,{useEffect, useState} from 'react';
import { Grid,Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import NumericLabel from 'react-pretty-numbers';
import {assetTypeLabel, displayDateFormatShort, prettyNumberParamsDB,} from '../../../constants';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus, checkPermission, getLocalStorageInfo } from '../../../utils';
import appConfig from '../../../config';
import { PageLoader } from '../../../shared_elements';

const ShopVisitTitle = ({event, assemblyType, goBack}) => {
  let userInfo = getLocalStorageInfo();
  const [assemblyCardData,setAssemblyCardData] = useState()
  const [loading,setLoading] = useState()
  useEffect(() => {
    setLoading(true)
    if(event?.asset_slug){
      globalGetService(`/maintenance/asset-type/${assemblyType}/asset/${event?.asset_slug}/shopvisit/${event?.id}/cashflow-card/`)
      .then(response => {
        if (checkApiStatus(response)) {
          setLoading(false)
          setAssemblyCardData(response?.data?.data)
        }
      })
    }
  }, [event?.asset_slug,assemblyType])
  return (
    <> <Grid container spacing={0} className='title-info'>
    <Grid xs={8} >
      <ArrowBackIcon color="primary" className="arrow-icon" onClick={goBack}/>
      <h4>{event.name}</h4>
      <p style={isMobile ? {fontSize:"12px"} : {}}>{assemblyType=='airframe'? 'Event': 'Shop Visit'} Date : {moment(event.shop_visit_date).format(displayDateFormatShort)} </p>
      {event?.asset_slug &&event?.contract_id ?  <Grid className='redirect-button-div'>
        {checkPermission('contracts', 'qualified_maintenance_event', 'R') ? <Button color="primary" variant="outlined" className='mr-8'
          onClick={() => {
            if (checkPermission('contracts', 'qualified_maintenance_event', 'R') ) {
               window.open(`${appConfig.domain.lease}${assemblyType === "airframe" ? "aircraft" : assemblyType}/${event?.asset_slug}/contract/${event?.contract_id}/qualified-maintenance`)
            }
          }
          }
        >
         Qualified maintenance events
        </Button> : null}

        {userInfo?.user?.permission?.contracts && Object.keys(userInfo?.user?.permission?.contracts)?.length ?<Button  color="primary" variant="outlined" 
         onClick={() => {
          if (userInfo?.user?.permission?.contracts && Object.keys(userInfo?.user?.permission?.contracts)?.length && event?.asset_slug &&event?.contract_id ) {
             window.open(`${appConfig.domain.lease}${assemblyType === "airframe" ? "aircraft" : assemblyType}/${event?.asset_slug}/contract/list/${event?.contract_id}`)
          }
        }
        }
        >
          Lease Agreement details
        </Button> : null }
        
        </Grid> : null}
    </Grid>
      <Grid  xs={4} className='justify-content-end'> <div style={{ display: 'flex' }}>
        <div style={{marginRight:"12px"}}> <div className='fund-title'>Fund Balance </div>
          <div className='fund-date-title'>As of Date</div>
          <div className="fund-date">({event.shop_visit_date ? moment(event.shop_visit_date).format(displayDateFormatShort):""})</div></div>
             <div className="reserve-account-card">
              <h3 >{assemblyType && assetTypeLabel[assemblyType]?.label}</h3>
               {assemblyType =='engine' ? <div style={{display:"flex"}}>
                 <div style={{marginRight :"18px"}}>
                <h5>PRSV</h5>
                <p>
                  <NumericLabel params={prettyNumberParamsDB}>{assemblyCardData?.prsv_total ? assemblyCardData?.prsv_total : 0}</NumericLabel>
                </p>
              </div>
              <div>
                <h5>LLP Replacement</h5>
                <p>
                  <NumericLabel params={prettyNumberParamsDB}>{assemblyCardData?.llp_total ? assemblyCardData?.llp_total : 0}</NumericLabel>
                </p>
              </div></div> : <div>
                <h5>Fund Balance</h5>
                <p>
                  <NumericLabel params={prettyNumberParamsDB}>{assemblyCardData?.amount ? assemblyCardData?.amount :0}</NumericLabel>
                </p>
              </div> }
             
            {/* </div> */}
        </div></div></Grid>
  </Grid>
  {loading ? <PageLoader /> :null}
  
  </>
   
  )
}
export default ShopVisitTitle;
